import useToken from './useToken';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';


export default function LogOut() {
    const { clearToken } = useToken();
    let history = useHistory();    

    useEffect(() => {
        async function clearSession() {
        history.push('/');
        await clearToken();
        window.location = '/';
        }

        clearSession();
        })


    return (<div>You have been Logged Out</div>)
}